(ns ycweb.app.website.dlp.widgets.banner
  (:require
   [rum.core :as rum]
   [util.transform :as trf]
   [ycweb.app.website.common :as web-common]
   [ycweb.components.buttons :as buttons]
   [ycweb.util.core :as u]))

(rum/defc feature-panel-single < rum/reactive [app-atom banner columns]
  (let [{:banners/keys
         [colour-palette-id colour-name url
          responsive-public-id image-alt lead-in-text
          text-color description button-text title]}
        banner

        columns (trf/tonumber columns)]
    [:article
     {:class
      (u/bem
        :feature-banner
        [(when (> columns 2) :small)]
        :flex-grid-content
        (when colour-palette-id
          (str "u-bg-" colour-name)))}
     (u/wrap-element
       url
       [:a.u-block-link
        {:href url}]
       (list
         [:div.feature-banner__hero
          (web-common/lazy-image app-atom
            responsive-public-id
            {:class [:feature-banner__image]}
            {:w 480 :mw 480 :max-dpr 1 :alt image-alt})]
         [:div
          {:class
           (u/bem
             :feature-banner__content
             [(when
                (and
                  (not= text-color "dark")
                  colour-palette-id)
                :reversed)])}
          [:h2.feature-banner__title
           (when lead-in-text
             [:span.feature-banner__lead-in
              lead-in-text
              [:span.u-hidden-from-view " "]])
           [:span
            {:class
             (u/bem :feature-banner__title-text [(when (> columns 2) :small)])
             :dangerouslySetInnerHTML {:__html title}}]]
          (when (and (= columns 2) description)
            [:p.feature-banner__description
             {:dangerouslySetInnerHTML {:__html description}}])
          (when button-text
            [:footer.feature-banner__footer
             (cond
               (= columns 2)
               (buttons/button-web button-text
                 {:style "secondary"
                  :full true})

               :else
               [:p.feature-banner__text-link
                button-text])])]))]))

(rum/defc feature-panel < rum/reactive [app-atom {:keys [columns section-size banners underlined]}]
  (when (not-empty banners)
    [:div
     {:class
      (u/bem :yc-section [(str section-size (when underlined "-underline"))])}
     [:div
      {:class "flex-grid-group  flex-grid-group--align-left"}
      (map
        (fn [banner]
          [:div
           {:class
            (u/bem :flex-grid-block [:m-1-2 (when (= (trf/tonumber columns) 3) :l-1-3)])}
           (feature-panel-single app-atom banner columns)])
        banners)]]))

(rum/defc hero-single < rum/reactive [app-atom banner]
  (let [{:banners/keys
         [colour-palette-id colour-name url
          responsive-public-id image-alt lead-in-text
          logo-public-id title
          text-color description button-text]}
        banner]

    [:a.hero-banner
     {:href url}
     [:div.hero-banner__image-wrapper
      {:class (str "u-bg-" (when colour-palette-id colour-name))}
      (web-common/lazy-image app-atom
        responsive-public-id
        {:class "hero-banner__image"}
        {:q "auto"
         :alt
         (cond
           (u/presence image-alt)
           image-alt

           (and (u/presence lead-in-text) (u/presence title))
           (str lead-in-text " - " title)

           :else
           title)})]
     [:div.hero-banner__text-wrapper
      {:class (str "u-bg-" (when colour-palette-id colour-name))}
      [:div
       {:class
        (u/bem :hero-banner__text [(keyword text-color)])}

       (when (:lead_in_text banner)
         [:small.hero-banner__lead-in
          lead-in-text])

       (when (:logo_public_id banner)
         [:div.hero-banner__logo-wrapper
          (web-common/lazy-image app-atom
            logo-public-id
            {:class "hero-banner__logo"}
            {:q "auto"
             :alt (str "Small logo for " (:banner/name banner))})])

       [:h2.hero-banner__title title]

       (when (u/presence description)
         [:p.hero-banner__description
          {:dangerouslySetInnerHTML {:__html description}}])

       (when (u/presence button-text)
         [:div.hero-banner__cta
          (buttons/button-web button-text
            {:style (if (= text-color "dark") :primary :secondary)
             :full true})])]]]))

(rum/defc hero < rum/reactive [app-atom {:keys [section-size banners]}]
  [:div
   {:class (u/bem :yc-section [section-size])}
   (map #(hero-single app-atom %) banners)])

(rum/defc bar-message-single < rum/reactive [app-atom banner]
  (let [{:banners/keys
         [colour-palette-id colour-name url title description
          text-color button-text link-type icon lead-in-text]}
        banner
        help? (= link-type "help")]

    [:a.u-block-link
     {:href (if url url "#")
      :class
      (u/bem
        :card [:no-border]
        :text-card [:small]
        (when colour-palette-id (str "u-bg-" colour-name))
        (when help? "js-mfp-open-url"))
      :rel "nofollow"
      :data-title (when help? lead-in-text)
      :data-content-wrapper-class (when help? "yc-simple-text")
      :target_url (when help? (str url "&overrideincludes=blank"))}
     [:p.u-text-center
      {:class (u/bem :yc-paragraph [:flush] (str "u-text-" (keyword (if (= text-color "dark")
                                                                      "dark"
                                                                      "white"))))}
      (when icon
        [:<>
         [:i {:class (u/bem :icon [:inline :in-copy :small (keyword icon) (keyword (str "is-" text-color))])}]
         " "])
      [:b (str title " ")]
      description
      " "
      [:span.u-text-underline button-text]]]))

(rum/defc bar-message < rum/reactive [app-atom {:keys [section-size banners]}]
  [:div
   {:class (u/bem :yc-section [section-size])}
   (map #(bar-message-single app-atom %) banners)])

(rum/defc home-page-main-categories-single < rum/reactive [app-atom banner]
  (let [{:banners/keys
         [url title responsive-public-id
          text-color image-alt lead-in-text]}
        banner]

    [:div
     {:class (u/bem :flex-grid-block [:t-1-2 :ml-1-4])}
     [:a.flex-grid-content.quad-banner
      {:href url
       :rel "nofollow"}
      (web-common/lazy-image app-atom
        responsive-public-id
        {:class "yc-simple-image  yc-simple-image--full"}
        {:w 320
         :mw 240
         :h 381
         :q "auto"
         :alt
         (cond
           (u/presence image-alt)
           image-alt

           (and (u/presence lead-in-text) (u/presence title))
           (str lead-in-text " - " title)

           :else
           title)})

      [:div
       {:class (u/bem :quad-banner__text [:top (keyword text-color)])}
       (when lead-in-text
         [:span.quad-banner__lead-in
          lead-in-text
          [:span.u-hidden-from-view " "]])
       [:span.quad-banner__title title]]]]))

(rum/defc home-page-main-categories < rum/reactive [app-atom {:keys [section-size banners]}]
  [:div
   {:class (u/bem :yc-section [section-size])}
   [:div.flex-grid-group
    (map
      #(home-page-main-categories-single app-atom %)
      banners)]])

(rum/defc banner-component < rum/reactive [app-atom _ {:keys [properties] :as component}]
  (let
    [{:banner/keys
      [banners banner-type feature-count
       admin-view spacer-size has-line]} properties

     has-line? (trf/toboolean has-line)

     section-size
     (cond
       (and (= spacer-size "standard") has-line?)
       "standard-underline"

       (and (= spacer-size "medium") has-line?)
       "medium-underline"

       (and (= spacer-size "medium") (not has-line?))
       "medium"

       (and (= spacer-size "standard") (not has-line?))
       "standard"

       :else
       "standard")]

    [:<>
     (when admin-view
       [:div.dlp-edit-spacer-label
        [:b
         {:class (u/bem :text-pill [:light :medium])}
         "Only displays on preview."]])

     (when (not-empty banners)
       (case banner-type
         "feature panel"
         (feature-panel app-atom
           {:responsive true
            :columns feature-count
            :section-size section-size
            :banners banners})

         "hero"
         (hero app-atom
           {:responsive true
            :section-size
            (if (= (:name component) "banner")
              section-size
              "large")
            :banners banners})

         "bar message"
         (bar-message app-atom
           {:responsive true
            :section-size section-size
            :banners banners})

         "home page main categories"
         (home-page-main-categories app-atom
           {:responsive true
            :section-size section-size
            :banners banners})))]))